import StoryblokVisualEditor from "components/StoryblokVisualEditor"
import richText from "utilities/richText"

export default function IconCard({ blok }) {
  return (
    <StoryblokVisualEditor story={blok}>
      <div className="flex flex-col max-w-xl lg:flex-[1_1_280px] text-stone-light bg-evergreen p-6 rounded-10 shadow-md prose-a:font-bold">
        {blok.heading && <h4 className="text-l2 font-medium mb-2">{blok.heading}</h4>}
        <div>{richText(blok.description)}</div>
      </div>
    </StoryblokVisualEditor>
  )
}
